import { Component, Input } from '@angular/core';
import { AuthService, SharedDataService } from 'elbuild-ui-lib-core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from 'src/environments/environment';
import { Customer } from 'yf-commerce-model-ui-lib';
import { RouteGuardService, ShopCartService, WishlistService } from 'yf-commerce-ui-lib';
import { AccountService } from '../services/account.service';

@Component({
	selector: 'app-header',
	standalone: false,
	templateUrl: './header.component.html',
	styleUrl: './header.component.scss'
})
export class HeaderComponent {
	loggedUser: Customer;

	@Input() class: string = 'footer-light'; // Default class
	ismobile: any;

	logo = environment.logo || 'logo.png';

	constructor(private sharedDataService: SharedDataService, private deviceService: DeviceDetectorService,
		private accountservice: AccountService
	) {
		this.sharedDataService.currentLoggedUser.subscribe(data => {
			this.loggedUser = data as unknown as Customer;

		});

		this.ismobile = this.deviceService.isMobile() || this.deviceService.isTablet();
	}

	get baseURL() {
		return environment.baseURL;
	}

	logout(): void {
		this.accountservice.logout(true, true);
	}

}
